import * as CryptoJS from "crypto-js";
import * as Const from "./_Const";

export function isNullOrEmpty(text) {
  let isNullOrEmpty = false;

  if (text === "null" || text === "") {
    isNullOrEmpty = true;
  }

  if (typeof text !== "undefined" && text) {
    isNullOrEmpty = false;
  } else {
    isNullOrEmpty = true;
  }

  //Tento kod vrátí true, pokud je hodnota: null, undefined, "", 0, false nebo NaN nebo obsahuje "    " prazdne znaky.
  isNullOrEmpty = !text || text.trim().length === 0;

  return isNullOrEmpty;
}

export function isNullOrEmptyList(list, item) {
  let isEmpty = true;

  if (list) {
    list.forEach(function (arrayItem) {
      if (isEmpty) {
        if (!isNullOrEmpty(arrayItem[item])) {
          isEmpty = false;
        }
      }
    });
  }

  return isEmpty;
}

/**
 * Bezpečný převod stringu na integer.
 * @param {string} value - Hodnota k převodu
 * @param {number} defaultValue - Hodnota vrácená při neúspěchu (výchozí 0)
 * @param {number} radix - Soustava (výchozí 10)
 * @returns {number} - Výsledek jako celé číslo
 */
export function tryParseInt(value, defaultValue = 0, radix = 10) {
  const parsed = parseInt(value, radix);

  // Kontrola, zda výsledek není NaN (Not a Number)
  if (isNaN(parsed)) {
    return defaultValue;
  }

  return parsed;
}

export function parseBool(str) {
  // console.log(typeof str);
  // strict: JSON.parse(str)

  if (str == null) return false;

  if (typeof str === "boolean") {
    if (str === true) return true;

    return false;
  }

  if (typeof str === "string") {
    if (str == "") return false;

    str = str.replace(/^\s+|\s+$/g, "");
    if (str.toLowerCase() == "true" || str.toLowerCase() == "yes") return true;

    str = str.replace(/,/g, ".");
    str = str.replace(/^\s*\-\s*/g, "-");
  }

  // var isNum = string.match(/^[0-9]+$/) != null;
  // var isNum = /^\d+$/.test(str);
  if (!isNaN(str)) return parseFloat(str) != 0;

  return false;
}

export function getPhoneLink(phone) {
  if (!phone) {
    return "";
  }

  return `tel:${phone.replace(/\s/g, "")}`;
}

export function getEmailLink(email) {
  if (!email) {
    return "";
  }

  return `mailto:${email.replace(/\s/g, "")}`;
}

export function stripHtml(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function textShortener(text, len) {
  if (text && text.length > len) {
    text = text.substring(0, len) + "... (zkrácený text)";
  }
  return text;
}

export function needGoToDetail(text, len) {
  let needGoToDetail = false;
  if (text && text.length > len) {
    needGoToDetail = true;
  }
  return needGoToDetail;
}

export function encrypt(text) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const cipherText = CryptoJS.AES.encrypt(text, secretKey).toString();
  return cipherText;
}

export function decrypt(text) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const bytes = CryptoJS.AES.decrypt(text, secretKey);
  const plainText = bytes.toString(CryptoJS.enc.Utf8);
  return plainText;
}

export function getAuthConfig(uid) {
  //console.log(uid, process.env.REACT_APP_API_USERNAME, process.env.REACT_APP_API_PASSWORD);

  const base64 = "Basic " + btoa(uid + ":" + process.env.REACT_APP_API_USERNAME + ":" + process.env.REACT_APP_API_PASSWORD);
  //console.log(base64);

  return {
    headers: {
      Authorization: base64,
    },
  };
  //return { Authorization: "Basic " + btoa(uid + ":" + username + "" + pass) };
}

export function getRandomUID(len, numberOnly = false) {
  const chars = numberOnly ? "0123456789" : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uid = "";
  for (let i = 0; i < len; i++) {
    uid += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return uid;
}

let lastGeneratedCardIDDay = null; // Uchovává poslední den, kdy byla kolekce resetována (Date object)
let todayUsedNonCardIdentificatorList = []; // Array použitých ID

/**
 * Pomocná metoda: Získá dnešní datum s časem nastaveným na 00:00:00.
 * Zajišťuje správné srovnání dnů bez vlivu času.
 * @returns {Date} Dnešní datum o půlnoci.
 */
function getTodayDateOnly() {
  const d = new Date();
  d.setHours(0, 0, 0, 0); // Nastavení času na půlnoc
  return d;
}

/**
 * Pomocná metoda: Porovnává, zda je Date1 (např. dnes) po Date2 (např. včera).
 */
function isDateAfter(date1, date2) {
  // Porovnává timestamp (milisekundy od epochy)
  return date1.getTime() > date2.getTime();
}

/**
 * Kontroluje, zda bylo ID pacienta dnes již použito.
 *
 * @param {string} id - Identifikátor pacienta (např. číslo karty).
 * @returns {boolean} true, pokud ID již existuje, false, pokud je nové.
 */
function checkPatientIdentificatorExistsToday(id) {
  let exists = true;

  // 1. Získání dnešního data o půlnoci (ekvivalent LocalDate)
  const today = getTodayDateOnly();

  // 2. Inicializace lastGeneratedCardIDDay při restartu
  if (lastGeneratedCardIDDay === null) {
    lastGeneratedCardIDDay = getTodayDateOnly();
  }

  // 3. Kontrola resetu kolekce (pokud je dnes NOVÝ den)
  if (isDateAfter(today, lastGeneratedCardIDDay)) {
    if (todayUsedNonCardIdentificatorList !== null) {
      console.log("helper", "getRandomIdentificator - checkPatientIdentificatorExistsToday mazu data pro novy den");

      // Smazání kolekce (nastavení na prázdné pole)
      todayUsedNonCardIdentificatorList = [];
      // Nastavení poslední dne na dnešek
      lastGeneratedCardIDDay = getTodayDateOnly();
    }
  }

  // 4. Kontrola existence ID a přidání nového
  if (todayUsedNonCardIdentificatorList !== null) {
    // JavaScript používá .indexOf() a porovnání s -1
    if (todayUsedNonCardIdentificatorList.indexOf(id) === -1) {
      exists = false;
      // Přidání ID do pole
      todayUsedNonCardIdentificatorList.push(id);
    }
  }

  console.log(lastGeneratedCardIDDay, todayUsedNonCardIdentificatorList);

  return exists;
}

function getRandomAlphabetChar() {
  // Generuje náhodný velký znak (A-Z)
  const alphabet = "ABCDEFHJKLMNPQVXZ"; //"ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const randomIndex = Math.floor(Math.random() * alphabet.length);
  return alphabet.charAt(randomIndex);
}

function getRandomInt(min, max) {
  // Generuje náhodné číslo v rozsahu [min, max] včetně (ekvivalent Java ThreadLocalRandom)
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getRandomIdentificator() {
  let idetificator = null;
  const MAX_ATTEMPTS = 3;

  // Zkusit 3 pokusy na nalezení unikátního ID
  for (let i = 0; i < MAX_ATTEMPTS; i++) {
    // 1. Generování náhodného čísla 10-99 (rand.nextInt(99-10+1) + 10)
    const randomNumber = getRandomInt(10, 99);

    // 2. Sestavení ID (Znak + Číslo)
    // Přímá konkatenace v JS zajistí převod na řetězec
    idetificator = getRandomAlphabetChar() + String(randomNumber);

    // 3. Kontrola unikátnosti (předpokládá existenci checkPatientIdentificatorExistsToday)
    if (!checkPatientIdentificatorExistsToday(idetificator)) {
      console.log("helper", `getRandomIdentificator ${idetificator} not exists, attempt: ${i}`);
      break; // Nalezeno unikátní ID, ukončíme smyčku
    } else {
      console.log("helper", `getRandomIdentificator ${idetificator} already exists, attempt: ${i}`);
    }
  }

  return idetificator;
}

export function formatString(template, ...args) {
  // Projde text a nahradí %1 za první argument, %2 za druhý atd.
  return template.replace(/%(\d+)/g, (match, number) => {
    const index = number - 1;
    return typeof args[index] !== "undefined" ? args[index] : match;
  });
}

export function formatNamesForInfoPanel(item, infoPanelState) {
  //     pid: 1494436,
  // inQueue: 17709785519065894,
  // dob: "12/12/1950",
  // name: "KAREL",
  // surname: "NOVÁK",
  // identification: "G50",
  // nameResolver: null, //zobraju se v dle nastaveneho formatu jemna prijmeni jen u volaneho pacienta pridanim data narozeni "*12.12.",
  // isWithoutCard: false,
  let part1 = "";
  let part2 = "";

  function toDisplayCase(s) {
    const delimiters = " '-/";
    let capNext = true;

    return s
      .split("")
      .map((char) => {
        const res = capNext ? char.toUpperCase() : char.toLowerCase();
        capNext = delimiters.includes(char);
        return res;
      })
      .join("");
  }

  function getSurname(item) {
    if (item.isWithoutCard) {
      return `(${item.identification}) Pacient`;
    } else {
      return !isNullOrEmpty(item.surname) ? toDisplayCase(item.surname) : item.surname;
    }
  }

  function getName(item) {
    return !isNullOrEmpty(item.name) ? toDisplayCase(item.name) : item.name;
  }

  function getFirstLetter(item) {
    if (!isNullOrEmpty(item)) {
      item = item.substring(0, 1) + ".";
    }
    return item;
  }

  function getNameWithResolver(item) {
    if (!isNullOrEmpty(item.name)) {
      if (!isNullOrEmpty(item.nameResolver)) {
        return `${toDisplayCase(item.name)} (${item.nameResolver})`;
      } else {
        return toDisplayCase(item.name);
      }
    } else {
      return item.name;
    }
  }

  function getNameMonogramWithResolver(item) {
    let val = getFirstLetter(item.name);
    if (!isNullOrEmpty(val)) {
      if (!isNullOrEmpty(item.nameResolver)) {
        val = `${val} (${item.nameResolver})`;
      }
    }
    return val;
  }

  function getMonogramWithResolverFor(s, nameRosolver) {
    let val = getFirstLetter(s);
    if (!isNullOrEmpty(val)) {
      if (!isNullOrEmpty(nameRosolver)) {
        val = `${val} (${nameRosolver})`;
      }
    }
    return val;
  }

  function getNameMonogramWithResolver(item) {
    return getMonogramWithResolverFor(item.name, item.nameResolver);
  }

  function getSurnameMonogramWithResolver(item) {
    return getMonogramWithResolverFor(item.surname, item.nameResolver);
  }

  function getNameMonogram(item) {
    return getFirstLetter(item.name);
  }

  function getSurnameMonogram(item) {
    return getFirstLetter(item.surname);
  }

  function getSurnameMonogramDob(item) {
    return getMonogramDobFor(item.surname, item.dob);
  }

  function getNameMonogramDob(item) {
    return getMonogramDobFor(item.name, item.dob);
  }

  function getMonogramDobFor(s, dob) {
    let val = getFirstLetter(s);
    if (!isNullOrEmpty(val)) {
      const computedDob = dob?.replaceAll("/", ".");
      if (!isNullOrEmpty(computedDob)) {
        val = `${val} (${computedDob})`;
      }
    }
    return val;
  }

  function getSurnameWithIdentification(item) {
    if (item.isWithoutCard) {
      return `(${item.identification}) Pacient`;
    } else {
      return !isNullOrEmpty(item.surname) ? `(${item.identification}) ${toDisplayCase(item.surname)}` : `(${item.identification}) ${item.surname}`;
    }
  }

  function getNameWithIdentification(item) {
    return !isNullOrEmpty(item.name) ? `(${item.identification}) ${toDisplayCase(item.name)}` : `(${item.identification}) ${item.name}`;
  }

  //console.log("setFormattedNames", item);

  //v pripade ze se zobrazi format Pacient - A99 tak se nebude zobazovat nic jineho tedy ani bez karticky
  if (infoPanelState?.nameFormat === Const.NAME_FORMAT_TYPE_IDENTIFICATION) {
    //Pacient - A99
    part1 = `Pacient - ${item?.identification}`;
    part2 = "";
  } else {
    if (item.isWithoutCard) {
      part1 = getSurname(item);
      if (!isNullOrEmpty(getName(item))) {
        part2 = getName(item)?.toLowerCase(); //Bez Karticky na bez karticky
      }
    } else {
      switch (infoPanelState?.nameFormat) {
        case Const.NAME_FORMAT_TYPE_SURNAME_NAME: //Novak Jan
          part1 = getSurname(item);
          part2 = getNameWithResolver(item);
          break;
        case Const.NAME_FORMAT_TYPE_SURNAME_NAME_FIRST_LETTER: // Novak J.
          part1 = getSurname(item);
          part2 = getNameMonogramWithResolver(item);
          break;
        case Const.NAME_FORMAT_TYPE_NAME_SURNAME_FIRST_LETTER: // Jan. N.
          part1 = getName(item);
          part2 = getSurnameMonogramWithResolver(item);
          break;
        case Const.NAME_FORMAT_TYPE_MONOGRAM: // J. N. (Jan Novak)
          part1 = getNameMonogram(item);
          part2 = getSurnameMonogramWithResolver(item);
          break;
        case Const.NAME_FORMAT_TYPE_MONOGRAM_DOB: // J. N. (* 14.01) (Jan Novak)
          part1 = getNameMonogram(item);
          part2 = getSurnameMonogramDob(item);
          break;
        case Const.NAME_FORMAT_TYPE_SURNAME_NAME_FIRST_LETTER_DOB: //Novak J. 1.1.2019
          part1 = getSurname(item);
          part2 = getNameMonogramDob(item);
          break;
        case Const.NAME_FORMAT_TYPE_NAME_SURNAME_FIRST_LETTER_DOB: //Jan N. 1.1.2019
          part1 = getName(item);
          part2 = getSurnameMonogramDob(item);
          break;
        case Const.NAME_FORMAT_TYPE_IDENTIFICATION_SURNAME_NAME: //(A99) Novak Jan
          part1 = getSurnameWithIdentification(item);
          part2 = getName(item);
          break;
        case Const.NAME_FORMAT_TYPE_IDENTIFICATION_SURNAME_NAME_FIRST_LETTER: //(A99)  Novak J.
          part1 = getSurnameWithIdentification(item);
          part2 = getNameMonogram(item);
          break;
        case Const.NAME_FORMAT_TYPE_IDENTIFICATION_NAME_SURNAME_FIRST_LETTER: //(A99) Jan N.
          part1 = getNameWithIdentification(item);
          part2 = getSurnameMonogram(item);
          break;
      }
    }
  }

  return { part1, part2 };
}
